import { useLayoutEffect, useState } from 'react'

import { SequenceCompletion } from '@/webgl/runner/scenarios/SequenceCompletion'

import RunnerGoalInvertLettersItemCollected from './RunnerGoalInvertLettersItemCollected'

export type RunnerGoalInvertLettersProps = {
  completion: SequenceCompletion
}

export default function RunnerGoalInvertLetters({ completion }: RunnerGoalInvertLettersProps) {
  const template = completion.view.template
  const replacement: Record<string, { goal: string; inverted: string }> = completion.view.replacement
  const collected = completion.blocks[completion.currentBlock].collected || []

  const [items, setItems] = useState<
    Array<{
      text: string
      replacement?: { goal: string; inverted: string }
    }>
  >([])

  useLayoutEffect(() => {
    const elements = template
      .split(/{(.*?)}/g)
      .filter((item) => item !== '')
      .map((item) => item.trim())

    const items = elements.map((element) => {
      const replacedKey = Object.keys(replacement).find((key) => key === element)
      const replacedValue = replacedKey ? replacement[replacedKey] : null

      return {
        text: element,
        replacement: replacedValue,
      }
    })
    setItems(items)
  }, [template, replacement, setItems])

  const hasTip = completion.view.extra?.id == 'social-studies-play-intro'

  return (
    <div className='RunnerGoalVariant Runner__goal-invert_letters relative px-12 md:px-24 flex items-center bg-tertiary border-4 border-mid-blue min-h-88 min-w-88 p-8 rounded-24 mt-20 text-body-l'>
      {items.map((item, index) => (
        <span key={index}>
          {item.replacement ? (
            <>
              {collected.includes(item.replacement.goal) ? (
                <RunnerGoalInvertLettersItemCollected item={item} />
              ) : (
                <span className={`z-2 ${hasTip ? 'underline' : ''}`}>{item.replacement.inverted}</span>
              )}
            </>
          ) : (
            <span className='z-2'>{item.text}</span>
          )}
        </span>
      ))}
    </div>
  )
}
